import { Body, Heading, Icon } from "@elaniintc/goes-design-system";
import { NodeCardsList } from "./node-cards-list";
import { cn } from "@/utils/theme";
import type { NodeExecutionType } from "@/types/entities/flows";
import { Skeleton } from "@/components/ui/skeleton";
import type { FormalityRequestType } from "@/types/entities/formality-request";

interface SystemNodeListProps {
  isLoading?: boolean;
  showNodeSkeleton?: boolean;
  nodes?: NodeExecutionType[];
  procedureId: string;
  showLoading?: boolean;
  hideHeader?: boolean;
  startIndex?: number;
  formalityRequest?: FormalityRequestType;
}

export const SystemNodeList = ({
  isLoading,
  showLoading,
  showNodeSkeleton,
  nodes = [],
  procedureId,
  hideHeader,
  startIndex = 0,
  formalityRequest,
}: SystemNodeListProps) => {
  if (nodes.length === 0 && !showLoading) {
    return null;
  }

  return (
    <div className="flex flex-col gap-3 pb-3">
      {!hideHeader && (
        <div>
          <Heading variant="h6" className="text-heading">
            Pasos de su solicitud
          </Heading>
          <Body className="text-body-quiet text-sm mt-1">
            Revise los pasos de la solicitud actual.
          </Body>
        </div>
      )}

      {nodes.length > 0 && (
        <div className="flex flex-col gap-2 w-full">
          <NodeCardsList
            nodes={nodes}
            procedureId={procedureId}
            formalityRequest={formalityRequest}
            startIndex={startIndex}
          />
        </div>
      )}

      {isLoading && showNodeSkeleton && (
        <Skeleton className="h-18 w-full rounded-md shrink-0" />
      )}

      {/* Loading spinner and label */}
      <div className={cn("flex gap-1 invisible", isLoading && "visible")}>
        <Icon
          name="spinner-third"
          type="fas"
          className="animate-spin text-on-disabled text-xs"
        />
        <Body color="quiet" size="xs">
          Estamos preparando su trámite, por favor espere un momento...
        </Body>
      </div>
    </div>
  );
};
